import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'body-xs',
            'body-sm',
            'body-md',
            'body-lg',
            'ui-xs',
            'ui-sm',
            'ui-md',
            'ui-lg',
            'heading-xs',
            'heading-sm',
            'heading-md',
            'heading-lg',
            'heading-xl',
            'heading-2xl',
            'heading-3xl',
            'label-xs',
            'label-sm',
            'caption-sm',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a numeric value as a percentage string (max 2 decimal places, trailing zeros stripped).
 * Returns the formatted string without the % symbol.
 */
export function formatPercent(value: number | undefined | null): string {
  if (value == null || isNaN(value) || !isFinite(value)) return `0`
  return String(Math.round(Number(value)))
}
